import { phoneFormat } from '../shared/util';

let cachedBrandContent = null;

const defaultContent = {
    aig: {
        clientName: '{CompanyName}',
        clientSite: '{ClientSite}',
        programName: '{ProgramName}',
        advantageProgramName: '{Advantage}',
        programPhone: phoneFormat('XXXXXXXXXX'),
        programEmail: 'XXXXXXXXXX@aig.com',
        pricingLevelName: 'Plan',
        advantageBenefits: {
            homeScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales'
            ],
            preferencesScreen: [
                'Zero upfront administrative work',
                'Significantly discounted pricing on shorter terms plans',
                'Reimbursement rate options',
                'Auto generated contract for every registration',
                'Profit margin opportunity on all sales'
            ]
        }
    }
};

export const WhySellContent = (client) => {
    const brandContent = getBrandContent(client);
    const contentData = {
        lennox: {
            heading: 'Two Simple Purchase Paths',
            para1: `${brandContent?.clientName} ${brandContent?.programName} provides the ability to seamlessly choose your desired manufacturer's warranty and ${brandContent?.programName} upgraded coverage, all while registering ${brandContent?.clientName} products.`,
            para2: `The ${brandContent?.programName} portal is easy to access from ${brandContent?.clientSite} and provides a simple, user friendly way to purchase ${brandContent?.programName} coverage options.`
        },
        rheem: {
            heading: 'Order Processing Made Easy',
            para1: 'Advanced applies pre-selected labor coverage automatically every time you register equipment, eliminating the administration burden of order processing.',
            para2: 'Express allows you to apply coverage to individual registrations using the Protection Plus Portal.',
            para3: 'The Protection Plus Portal is easy to access from MyRheem/MyRuud. It provides a simple way to submit post registration sales (new and existing installations) and manage contracts.'
        },
        carrier: {
            heading: 'Order Processing Made Easy',
            para1: 'Ease applies pre-selected labor coverage automatically every time you register equipment, eliminating the administration burden of order processing.',
            para2: 'Select allows you to apply coverage to individual registrations using the Climate Shield Complete Portal.',
            para3: 'The Climate Shield Complete Portal is easy to access from www.climateshieldcomplete.com. It provides a simple way to submit post registration sales (new and existing installations) and manage contracts.'
        },
        ge: {
            heading: 'Promote Business Growth and Customer Satisfaction',
            para1: `${brandContent?.programName}'s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the systems you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
            para2: 'Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process.'
        },
        icp: {
            heading: 'Order Processing Made Easy',
            para1: `${brandContent?.advantageProgramName} applies pre-selected labor coverage automatically every time you register equipment, eliminating the administration burden of order processing.`,
            para2: `${brandContent?.porProgramName} allows you to apply coverage to individual registrations using ${brandContent?.programName} Portal.`,
            para3: `The ${brandContent?.programName} Portal is easy to access from ${brandContent?.clientName} product registration site. It provides a simple way to submit post registration sales (new and existing installations) and manage contracts.`
        },
        homedepot: {
            heading: 'Order Processing Made Easy',
            para1: `${brandContent?.advantageProgramName} eliminates upfront data entry of sales. The extended service agreements (ESAs) will be created through an automated process based on the coverage term and reimbursement plan options you select when enrolling in the ${brandContent?.advantageProgramName} program.`,
            para2: `Select allows you to apply coverage to individual installations using ${brandContent?.programName} Portal.`
        },
        mcc: {
            heading: 'Promote Business Growth and Customer Satisfaction',
            para1: `${brandContent?.programName}'s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the system you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
            para2: 'Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process.'
        },
        trane: {
            heading: 'Promote Business Growth and Customer Satisfaction',
            para1: `${brandContent?.programName}’s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the systems you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
            para2: 'Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process.'
        },
        nordyne: {
            heading: 'Promote Business Growth and Customer Satisfaction',
            para1: `${brandContent.programName}’s extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the systems you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
            para2: 'Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process.'
        },
        mainline: {
            heading: 'Promote Business Growth and Customer Satisfaction',
            para1: `${brandContent.programName}’ extended service agreements are a great way to add revenue to your business without requiring additional equipment inventory or overhead costs. While the system you install provides a product to your customer, including an extended service agreement builds a lifetime relationship with them.`,
            para2: 'Including an extended service agreement with your original proposal helps your customer recognize it as an added benefit, rather than an added cost at the end of the sales process.'
        }
    };
    return contentData[client];
};

export const setBrandContent = (data) => {
    cachedBrandContent = data;
};

export const getBrandContent = (account) => {
    const accountLower = account.toLowerCase().replace(/ /g, '');
    if (account && accountLower && cachedBrandContent) {
        if (account === 'whatscovered') {
            return cachedBrandContent?.whatscovered;
        } else if (account === 'coveragetype') {
            return cachedBrandContent?.coveragetype;
        } else if (account === 'advantageBenefits') {
            return cachedBrandContent?.advantageBenefits;
        } else if (account === 'whatscoveredSlider') {
            return cachedBrandContent?.whatscoveredSlider;
        } else {
            const accountContent = {
                ...cachedBrandContent?.account,
                programPhone: phoneFormat(cachedBrandContent?.account?.programPhone)
            };
            return accountContent;
        }
    }

    return defaultContent.aig;
};

export const getProfileMenus = (account) => {
    const accountLower = account.toLowerCase().replace(/ /g, '');
    const profileMenus = {
        lennox: {
            dealerInformation: true,
            advantagePrograms: true,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        rheem: {
            dealerInformation: true,
            advantagePrograms: true,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        carrier: {
            dealerInformation: true,
            advantagePrograms: true,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        ge: {
            dealerInformation: true,
            advantagePrograms: false,
            coveragePreferences: false,
            billingPreferences: false,
            communication: false,
            security: true,
            showEnrollModal: false,
            landingResourceTab: true
        },
        icp: {
            dealerInformation: true,
            advantagePrograms: true,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        homedepot: {
            dealerInformation: true,
            advantagePrograms: true,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        mcc: {
            dealerInformation: true,
            advantagePrograms: false,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        trane: {
            dealerInformation: true,
            advantagePrograms: false,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        nordyne: {
            dealerInformation: true,
            advantagePrograms: false,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: true
        },
        mainline: {
            dealerInformation: true,
            advantagePrograms: false,
            coveragePreferences: true,
            billingPreferences: true,
            communication: true,
            security: true,
            showEnrollModal: false
        }
    };
    return profileMenus[accountLower];
};
